import React, { useEffect, useState } from "react";
import {
  IoBagHandle,
  IoCart,
  IoTimerOutline,
} from "react-icons/io5";
import { api_url } from "../../config";
import { useSelector } from "react-redux";
// import axios from "axios";
import { ColorRing } from "react-loader-spinner";
import api from "../../utils/api";
import { TbClockExclamation } from "react-icons/tb";
import { FaBoxOpen } from "react-icons/fa6";
import { PiChartLineDownDuotone } from "react-icons/pi";
import { BsPrescription } from "react-icons/bs";

const RetailDashboardInfo = () => {
  const [summary, setSummary] = useState([]);
  const { id, branch_id, token } = useSelector((state) => state.auth);
  const [loader, setLoader] = useState(false);

  const fetchSummary = async () => {
    try {
      setLoader(true);
      const response = await api.get(
        api_url + `/api/v1/retailer/user/${id}/branch/${branch_id}/summary`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data.data;
      // console.log('Summary API Response:', response.data);
      // console.log('Summary Data:', data);
      // console.log('Prescription Statuses:', data?.prescription_statuses);
      setSummary(data);
    } catch (error) {
      console.error('Error fetching summary:', error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchSummary();
  }, [id, token]);

  return (
    <div>
      {/* <ManagementInfo /> */}
      <div className="grid w-full h-[25em] grid-cols-2 gap-4 p-4 border-b font-lufga border-slate-200 md:grid-cols-3 lg:grid-cols-4 3xl:grid-cols-8">
        <div className="flex items-center justify-center gap-2 p-2 duration-300 shadow-md bg-sky-100 rounded-2xl sm:p-4 hover:scale-105 md:gap-6">
          <div>
            <IoBagHandle
              className="p-2 text-4xl text-white rounded-full bg-sky-500 sm:text-5xl "
            />
          </div>
          <div className="flex flex-col text-xs sm:text-base ">
            <p className="font-light text-gray-500 2xl:px-2">Suppliers</p>
            <div className="flex items-center mx-auto space-x-1 sm:space-x-2">
              {loader ? (
                <ColorRing
                  height="40"
                  width="40"
                  ariaLabel="color-ring-loading"
                  wrapperStyle={{}}
                  wrapperClass="color-ring-wrapper"
                  colors={[
                    "#e15b64",
                    "#f47e60",
                    "#f8b26a",
                    "#abbd81",
                    "#849b87",
                  ]}
                />
              ) : (
                <p className="text-lg font-semibold text-gray-700">
                  {summary?.supplier_count || '0'}
                </p>
              )}
              {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
            </div>
          </div>
        </div>

        {/* <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-white shadow-md sm:p-4 hover:scale-105 md:gap-6">
            <div><IoPeople size={44} className='p-2 text-white bg-yellow-400 rounded-full ' /></div>
            <div className='flex flex-col text-xs sm:text-sm '>
                <p className='font-light text-gray-500 2xl:px-2'>Users</p>
                <div className='flex items-center mx-auto space-x-1 sm:space-x-2'>
                    <p className='text-lg font-semibold text-gray-700'>0</p>
                </div>
            </div>
        </div> */}
        <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-green-100 shadow-md rounded-2xl sm:p-4 hover:scale-105 md:gap-6">
          <div>
            <IoCart

              className="p-2 text-4xl text-white bg-green-600 rounded-full sm:text-5xl"
            />
          </div>
          <div className="flex flex-col text-xs sm:text-base ">
            <p className="font-light text-gray-500 2xl:px-2">Pending orders</p>
            <div className="flex items-center mx-auto space-x-1 sm:space-x-2">
              <p className="text-lg font-semibold text-gray-700">
                {summary?.pending_orders || "0"}
              </p>
              {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 p-2 duration-300 shadow-md bg-sky-200 rounded-2xl sm:p-4 hover:scale-105 md:gap-6">
          <div>
            <IoTimerOutline
              className="p-2 text-4xl text-white rounded-full bg-sky-500 sm:text-5xl "
            />
          </div>
          <div className="flex flex-col text-xs sm:text-base ">
            <p className="font-light text-gray-500 2xl:px-2">Expiring soon</p>
            <div className="flex items-center mx-auto space-x-1 sm:space-x-2">
              {loader ? (
                <ColorRing
                  height="40"
                  width="40"
                  ariaLabel="color-ring-loading"
                  wrapperStyle={{}}
                  wrapperClass="color-ring-wrapper"
                  colors={[
                    "#e15b64",
                    "#f47e60",
                    "#f8b26a",
                    "#abbd81",
                    "#849b87",
                  ]}
                />
              ) : (
                <p className="text-lg font-semibold text-gray-700">
                  {summary?.expiring_soon || "0"}
                </p>
              )}
              {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-red-200 shadow-md rounded-2xl sm:p-4 hover:scale-105 md:gap-6">
          <div>
            <TbClockExclamation

              className="p-2 text-4xl text-white bg-red-800 rounded-full sm:text-5xl"
            />
          </div>
          <div className="flex flex-col text-xs sm:text-base ">
            <p className="font-light text-gray-500 2xl:px-2">Expired</p>
            <div className="flex items-center mx-auto space-x-1 sm:space-x-2">
              {loader ? (
                <ColorRing
                  height="40"
                  width="40"
                  ariaLabel="color-ring-loading"
                  wrapperStyle={{}}
                  wrapperClass="color-ring-wrapper"
                  colors={[
                    "#e15b64",
                    "#f47e60",
                    "#f8b26a",
                    "#abbd81",
                    "#849b87",
                  ]}
                />
              ) : (
                <p className="text-lg font-semibold text-gray-700">
                  {summary?.expired || "0"}
                </p>
              )}
              {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-gray-400 shadow-md rounded-2xl sm:p-4 hover:scale-105 md:gap-6">
          <div>
            <FaBoxOpen

              className="p-2 text-4xl text-white bg-black rounded-full sm:text-5xl"
            />
          </div>
          <div className="flex flex-col text-xs sm:text-base ">
            <p className="font-light text-gray-500 2xl:px-2">Out of stock</p>
            <div className="flex items-center mx-auto space-x-1 sm:space-x-2">
              {loader ? (
                <ColorRing
                  height="40"
                  width="40"
                  ariaLabel="color-ring-loading"
                  wrapperStyle={{}}
                  wrapperClass="color-ring-wrapper"
                  colors={[
                    "#e15b64",
                    "#f47e60",
                    "#f8b26a",
                    "#abbd81",
                    "#849b87",
                  ]}
                />
              ) : (
                <p className="text-lg font-semibold text-gray-700">
                  {summary?.out_of_stock || "0"}
                </p>
              )}
              {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-yellow-100 shadow-md rounded-2xl sm:p-4 hover:scale-105 md:gap-6">
          <div>
            <PiChartLineDownDuotone

              className="bg-[#FFC107] p-2 text-white rounded-full text-4xl sm:text-5xl"
            />
          </div>
          <div className="flex flex-col text-xs sm:text-base ">
            <p className="font-light text-gray-500 2xl:px-2">Low on stock</p>
            <div className="flex items-center mx-auto space-x-1 sm:space-x-2">
              {loader ? (
                <ColorRing
                  height="40"
                  width="40"
                  ariaLabel="color-ring-loading"
                  wrapperStyle={{}}
                  wrapperClass="color-ring-wrapper"
                  colors={[
                    "#e15b64",
                    "#f47e60",
                    "#f8b26a",
                    "#abbd81",
                    "#849b87",
                  ]}
                />
              ) : (
                <p className="text-lg font-semibold text-gray-700">
                  {summary?.low_on_stock || "0"}
                </p>
              )}
              {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
            </div>
          </div>
          {/* Add the total pending prescriptins inhere */}
        </div>
        <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-purple-100 shadow-md rounded-2xl sm:p-4 hover:scale-105 md:gap-6">
          <div>
            <BsPrescription
              className="p-2 text-4xl text-white bg-purple-600 rounded-full sm:text-5xl"
            />
          </div>
          <div className="flex flex-col text-xs sm:text-base ">
            <p className="font-light text-gray-500 2xl:px-2">Pending Prescriptions</p>
            <div className="flex items-center mx-auto space-x-1 sm:space-x-2">
              {loader ? (
                <ColorRing
                  height="40"
                  width="40"
                  ariaLabel="color-ring-loading"
                  wrapperStyle={{}}
                  wrapperClass="color-ring-wrapper"
                  colors={[
                    "#e15b64",
                    "#f47e60",
                    "#f8b26a",
                    "#abbd81",
                    "#849b87",
                  ]}
                />
              ) : (
                <p className="text-lg font-semibold text-gray-700">
                  {summary?.prescription_statuses?.pending || "0"}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div>
        {/* <div className="grid grid-cols-1 gap-4 p-4 sm:grid-cols-2 md:grid-cols-3 font-lufga">
          <div className="p-4 rounded-md shadow-md bg-green-50 hover:bg-green-100">
            <h2 className="mb-2 text-xs font-bold text-slate-600 sm:text-sm">
              Quantity Received
            </h2>
            <p className="text-slate-500">
              Number: <span>{summary?.quantity_received?.number}</span>
            </p>
            <p className="text-slate-500">
              Cost: <span>{summary?.quantity_received?.cost}</span>
            </p>
            <p className="text-slate-500">
              Sale Target: <span>{summary?.quantity_received?.saleTarget}</span>
            </p>
          </div>

          <div className="p-4 rounded-md shadow-md bg-blue-50 hover:bg-blue-100">
            <h2 className="mb-2 text-xs font-bold text-slate-600 sm:text-sm">
              Quantity Sold
            </h2>
            <p className="text-slate-500">
              Number: <span>{summary?.quantity_sold?.number}</span>
            </p>
            <p className="text-slate-500">
              Value: <span>{summary?.quantity_sold?.value}</span>
            </p>
          </div>

          <div className="p-4 rounded-md shadow-md bg-orange-50 hover:bg-orange-100">
            <h2 className="mb-2 text-xs font-bold text-slate-600 sm:text-sm">
              Quantity Available
            </h2>
            <p className="text-slate-500">
              Number: <span>{summary?.quantity_available?.number}</span>
            </p>
            <p className="font-bold">
              Target:{" "}
              <span
                className={`${summary?.quantity_available?.value < 0
                  ? "text-green-600 "
                  : "text-red-600"
                  }`}
              >
                {typeof summary?.quantity_available?.value === "number"
                  ? Math.abs(summary?.quantity_available.value).toLocaleString()
                  : "N/A"}
              </span>
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default RetailDashboardInfo;
